import _get from 'lodash/get'
import request from 'services/request'
import { createAuthorization } from 'services/auth'

/*
* Process chargebacks given their payment numbers
*/
export async function createUserHandleChargebacks ({ auth, server, paymentNumbers }) {
  const res = await request
    .post(`${server}/v1/payments/chargebacks`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send({ paymentNumbers })
  return _get(res, 'body', { success: false })
}

/*
* Process invoices given their invoice IDs
*/
export async function createUserHandleInvoicesPost ({ auth, server, invoiceIds }) {
  const res = await request
    .post(`${server}/v1/invoices/post`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send({ invoiceIds })
  return _get(res, 'body', { success: false })
}

/*
* Process subscription cancelations in batch
*/
export async function createUserSubscriptionCancelationsInBatch ({ auth, server, cancels }) {
  const response = await request
    .put(`${server}/v1/subscriptions/cancel`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send({ cancels })
  return _get(response, 'body', { success: false })
}

/*
* Turn on auto pay in batch
*/
export async function createTurnOnAutoPayInBatch ({ auth, server, accounts }) {
  const response = await request
    .post(`${server}/v1/subscriptions/auto-pay`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send({ accounts })
  return _get(response, 'body', { success: false })
}
